
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 309 360.685"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_20845","data-name":"Group 20845","transform":"translate(-189 -338)"}},[_c('path',{attrs:{"id":"Path_209248","data-name":"Path 209248","d":"M0,0H309V360.685l-267.7-4.66L0,319.627Z","transform":"translate(189 338)","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_189468","data-name":"Path 189468","d":"M510.091-303.325l40.939,34.433-9.113-46.759Z","transform":"translate(-321.091 963.033)","fill":"#dee3d8"}})])])
          )
        }
      }
    